import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import "../Styles/PoojaRecords.css";

function PoojaRecords() {

  const [poojas, setPoojas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [editingId, setEditingId] = useState(null);

  const [editPooja, setEditPooja] = useState({
    name: "",
    date: "",
    time: "",
    amount: "",
    description: ""
  });

  const loadPoojas = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await axios.get(
        "http://localhost:8080/api/poojas"
      );

      setPoojas(response.data);

    } catch (err) {
      console.error("Error loading poojas:", err);
      setError("Unable to load pooja records.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadPoojas();
  }, []);

  const handleEdit = (pooja) => {
    setEditingId(pooja.id);

    setEditPooja({
      name: pooja.name || "",
      date: pooja.date || "",
      time: pooja.time || "",
      amount: pooja.amount || "",
      description: pooja.description || ""
    });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;

    setEditPooja((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSave = async (id) => {
    try {

      await axios.put(
        `http://localhost:8080/api/poojas/${id}`,
        editPooja
      );

      setEditingId(null);

      await loadPoojas();

    } catch (err) {
      console.error("Error updating pooja:", err);
      alert("Unable to update pooja record.");
    }
  };

  const handleCancel = () => {
    setEditingId(null);

    setEditPooja({
      name: "",
      date: "",
      time: "",
      amount: "",
      description: ""
    });
  };

  const handleDelete = async (id) => {

    const confirmed = window.confirm(
      "Are you sure you want to delete this pooja record?"
    );

    if (!confirmed) {
      return;
    }

    try {

      await axios.delete(
        `http://localhost:8080/api/poojas/${id}`
      );

      await loadPoojas();

    } catch (err) {
      console.error("Error deleting pooja:", err);
      alert("Unable to delete pooja record.");
    }
  };

  // ================= EXPORT TO EXCEL =================

  const handleExportExcel = () => {

    if (poojas.length === 0) {
      alert("No pooja records available to export.");
      return;
    }

    const excelData = poojas.map((pooja, index) => ({
      "S.No": index + 1,
      "Pooja Name": pooja.name || "",
      "Date": pooja.date || "",
      "Time": pooja.time || "",
      "Amount": pooja.amount || "",
      "Description": pooja.description || ""
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Pooja Records"
    );

    worksheet["!cols"] = [
      { wch: 8 },
      { wch: 30 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 60 }
    ];

    XLSX.writeFile(
      workbook,
      "Pooja_Records.xlsx"
    );
  };

  return (

    <div className="pooja-records-page">
<div className="pooja-records-header">
  <h2>🙏 Pooja Records</h2>

  <div className="pooja-header-buttons">
    <button className="pooja-refresh-button" onClick={loadPoojas}>
      🔄 Refresh
    </button>
    <button className="pooja-export-button" onClick={handleExportExcel}>
      📊 Export Excel
    </button>
  </div>
</div>

      {loading && (
        <p className="pooja-records-message">
          Loading pooja records...
        </p>
      )}

      {error && (
        <p className="pooja-records-error">
          {error}
        </p>
      )}

      {!loading && !error && poojas.length === 0 && (
        <p className="pooja-records-message">
          No pooja records available.
        </p>
      )}

      {!loading && !error && poojas.length > 0 && (

        <div className="pooja-records-list">

          {poojas.map((pooja) => (

            <div
              className="pooja-record-card"
              key={pooja.id}
            >

              {editingId === pooja.id ? (

                <div className="pooja-edit-form">

                  <div className="pooja-edit-row">

                    <label>Name</label>

                    <input
                      type="text"
                      name="name"
                      value={editPooja.name}
                      onChange={handleEditChange}
                    />

                  </div>

                  <div className="pooja-edit-row">

                    <label>Date</label>

                    <input
                      type="date"
                      name="date"
                      value={editPooja.date}
                      onChange={handleEditChange}
                    />

                  </div>

                  <div className="pooja-edit-row">

                    <label>Time</label>

                    <input
                      type="text"
                      name="time"
                      value={editPooja.time}
                      onChange={handleEditChange}
                    />

                  </div>

                  <div className="pooja-edit-row">

                    <label>Amount</label>

                    <input
                      type="number"
                      name="amount"
                      value={editPooja.amount}
                      onChange={handleEditChange}
                    />

                  </div>

                  <div className="pooja-edit-row">

                    <label>Description</label>

                    <textarea
                      name="description"
                      value={editPooja.description}
                      onChange={handleEditChange}
                    />

                  </div>

                  <div className="pooja-edit-buttons">

                    <button
                      className="pooja-save-button"
                      onClick={() => handleSave(pooja.id)}
                    >
                      💾 Save
                    </button>

                    <button
                      className="pooja-cancel-button"
                      onClick={handleCancel}
                    >
                      ✖ Cancel
                    </button>

                  </div>

                </div>

              ) : (

                <div className="pooja-record-details">

                  <div className="pooja-record-title-row">

                    <h3>{pooja.name}</h3>

                    <div className="pooja-record-actions">

                      <button
                        className="pooja-edit-button"
                        onClick={() => handleEdit(pooja)}
                        title="Edit"
                      >
                        ✏️
                      </button>

                      <button
                        className="pooja-delete-button"
                        onClick={() => handleDelete(pooja.id)}
                        title="Delete"
                      >
                        🗑️
                      </button>

                    </div>

                  </div>

                  <div className="pooja-record-row">

                    <span className="pooja-label">
                      Date
                    </span>

                    <span className="pooja-value">
                      {pooja.date}
                    </span>

                  </div>

                  <div className="pooja-record-row">

                    <span className="pooja-label">
                      Time
                    </span>

                    <span className="pooja-value">
                      {pooja.time}
                    </span>

                  </div>

                  <div className="pooja-record-row">

                    <span className="pooja-label">
                      Amount
                    </span>

                    <span className="pooja-value">
                      ₹{pooja.amount}
                    </span>

                  </div>

                  <div className="pooja-record-description">

                    <span className="pooja-label">
                      Description
                    </span>

                    <p>
                      {pooja.description || "No description"}
                    </p>

                  </div>

                </div>

              )}

            </div>

          ))}

        </div>

      )}

    </div>
  );
}

export default PoojaRecords;